import { gsap } from 'gsap';

const init = () => {
  const overlay = document.querySelector('.js-transitionOverlay');
  let allLinks = document.querySelectorAll('a[href]');
  allLinks = Array.from(allLinks).filter(link => {
    // アンカーリンクを除外
    if(link.getAttribute('href').startsWith('#')) return false;
    // 外部リンクを除外
    if(link.hostname !== window.location.hostname) return false;
    return true;
  });

  // ブラウザの戻る・進むボタン対応
  window.addEventListener('pageshow', (event) => {
    if(event.persisted) {
      if(sessionStorage.getItem('pageTransition') === 'true') {
        sessionStorage.removeItem('pageTransition');
      }
      gsap.set(overlay, {
        clipPath: 'inset(100% 0% 0% 0%)',
        onComplete: () => {
          overlay.style.display = 'none';
        }
      });
    }
  });

  allLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.getAttribute('href');
      // TOPページへのリンクの場合、return
      if(href === '/' || href === '/index.html') {
        window.location.href = '/';
        return;
      }
      if(sessionStorage.getItem('pageTransition') === 'true' || href === window.location.href || href === window.location.pathname || href === window.location.pathname + window.location.search) {
        return;
      }
      if(overlay) {
        gsap.set(overlay, {
          clipPath: 'inset(100% 0% 0% 0%)'
        });
        gsap.to(overlay, {
          duration: 0.45,
          ease: "cubic-bezier(0.42, 0, 0.58, 1)",
          clipPath: 'inset(0% 0% 0% 0%)',
          onStart: () => {
            sessionStorage.setItem('pageTransition', 'true');
            overlay.style.display = 'flex';
          },
          onComplete: () => {
            window.location.href = href;
          }
        });
      }
    });
  });

  if(sessionStorage.getItem('pageTransition') === 'true') {
    gsap.set(overlay, {
      clipPath: 'inset(0% 0% 0% 0%)'
    });
    gsap.to(overlay, {
      duration: 0.4,
      delay: 0.4,
      ease: "cubic-bezier(0.42, 0, 0.58, 1)",
      clipPath: 'inset(0% 0% 100% 0%)',
      onStart: () => {
        sessionStorage.removeItem('pageTransition');
      },
      onComplete: () => {
        document.documentElement.classList.add('is-show');
        overlay.style.display = 'none';
      }
    });
  } else {
    gsap.set(overlay, {
      clipPath: 'inset(100% 0% 0% 0%)',
      onComplete: () => {
        overlay.style.display = 'none';
      }
    });
  }
};

export {
  init
};